<template>
  <div
    id="contents"
    class="interview-font"
  >
    <div class="company-area no-top">
      <p
        v-if="interview.companyName"
        class="company-name"
        data-test="company-name"
      >
        {{ interview.companyName }}
      </p>
      <h1
        v-if="interview.catchCopy"
        class="company-title interview-font"
        data-test="catch-copy"
      >
        {{ interview.catchCopy }}
      </h1>
    </div>
    <div
      v-if="interview.image"
      data-test="photo-main"
      class="contents-inner"
    >
      <div class="box_center">
        <img
          :src="getPhotoUrl(interview.image)"
          data-test="photo-main-img"
          class="max-w100 image-height-auto"
        >
      </div>
    </div>
    <p
      v-if="interview.intervieweePosition"
      class="-caption"
      data-test="position"
    >
      {{ interview.intervieweePosition }}
    </p>
    <p
      v-if="interview.intervieweeName"
      class="-caption fwB"
      data-test="interviewee-name"
    >
      {{ interview.intervieweeName }}<span>さん</span>
    </p>
    <p
      v-if="interview.intervieweeProfile"
      class="-caption pega-pre-wrap"
      data-test="profile"
      v-text="interview.intervieweeProfile"
    />

    <template v-for="(content, i) in interview.contentList">
      <div
        :key="i"
        class="contents-inner"
      >
        <div
          v-if="content.title || content.image || content.photoCaption"
          class="border_red remarks-block"
          :data-test="`content-${i}`"
          :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_gray.png) repeat top left;`"
        >
          <p
            v-if="content.title"
            class="pt10 pb10 fwB pega-pre-wrap"
            :data-test="`title-${i}`"
            v-text="content.title"
          />
          <img
            v-if="content.image"
            :src="getPhotoUrl(content.image)"
            :data-test="`photo-${i}`"
            class="interview-img-sub image-height-auto"
          >
          <p
            v-if="content.photoCaption"
            class="-caption"
            :data-test="`caption-${i}`"
            v-text="content.photoCaption"
          />
        </div>
        <p
          v-if="content.text"
          class="mt10 pega-pre-wrap content-text interview-font"
          :data-test="`text-${i}`"
          v-text="content.text"
        />
      </div>
    </template>

    <user-preview-menu-sp :titles="['募集情報', 'フォトクリップ']" />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/interview/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import UserPreviewMenuSp from '@/components/atoms/UserPreviewMenuSp'
export default {
  components: { UserPreviewMenuSp },
  mixins: [jobPreviewCommon],
  props: {
    interview: {
      type: Object,
      required: true
    }
  }
}
</script>
